const getAccessToken = () => {
    const token = localStorage.getItem("userToken");
    if (token !== null) {
        const tokenUserDetails = token.split(".")[1];
        let authToken = atob(
            tokenUserDetails.replace(/_/g, "/").replace(/-/g, "+")
        );

        return JSON.parse(authToken);
    }
    return null;
};

export default getAccessToken;